if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.isProcessingChange = false;
        this.isInitialized = false;
        this.hasAutoSelected = false;
      }

      get selectedOptionValues() {
        try {
          const selectedElements = this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          );

          const optionValues = Array.from(selectedElements)
            .map((element) => {
              return element.dataset.optionValueId || element.value;
            })
            .filter(Boolean);

          return optionValues;
        } catch (error) {
          return [];
        }
      }

      getInputForEventTarget(target) {
        return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        if (this.isInitialized) {
          return;
        }
        this.isInitialized = true;

        this.debouncedChangeHandler = this.debounce((event) => {
          this.handleVariantChange(event);
        }, 100);

        if (this.dataset.defaultFirst === "true" && !this.hasAutoSelected) {
          this.selectFirstAvailableOptions();
          this.hasAutoSelected = true;
        }

        this.addEventListener("change", this.debouncedChangeHandler);
      }
      selectFirstAvailableOptions() {
        const optionGroups = this.querySelectorAll("fieldset, select");
        let hasChanges = false;

        optionGroups.forEach((group) => {
          if (group.tagName === "FIELDSET") {
            const inputs = group.querySelectorAll(
              'input[type="radio"]:not(.disabled)'
            );
            const hasChecked = group.querySelector(
              'input[type="radio"]:checked'
            );
            if (inputs.length > 0 && !hasChecked) {
              inputs[0].checked = true;
              hasChanges = true;
            }
          } else if (group.tagName === "SELECT") {
            const options = Array.from(group.options);
            const firstAvailableOption = options.find(
              (option) => !option.disabled && option.value !== ""
            );
            if (firstAvailableOption && !group.value) {
              group.value = firstAvailableOption.value;
              options.forEach((opt) => opt.removeAttribute("selected"));
              firstAvailableOption.setAttribute("selected", "selected");
              hasChanges = true;
            }
          }
        });
        if (hasChanges) {
          setTimeout(() => {
            const event = new Event("change", { bubbles: true });
            this.dispatchEvent(event);
          }, 0);
        }
      }
      debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
          const later = () => {
            clearTimeout(timeout);
            func(...args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      }

      handleVariantChange(event) {
        if (this.isProcessingChange) {
          return;
        }
        this.isProcessingChange = true;
        try {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
            {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            }
          );

          this.triggerVariantChangeEvent(target);
        } catch (error) {
        } finally {
          this.isProcessingChange = false;
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          target.selectedOptions[0].setAttribute("selected", "selected");

          const swatchValue =
            target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value] > .swatch");
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              "unset"
            );
            selectedDropdownSwatchValue.classList.add("swatch--unavailable");
          }

          selectedDropdownSwatchValue.style.setProperty(
            "--swatch-focal-point",
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
          );
        } else if (tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(`.product-form__input`)
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      resetQuantityToDefault() {
        const quantityInputs = [
          document.querySelector('input[name="quantity"]'),
          document.querySelector("#Quantity-sticky-atc-bar"),
          document.querySelector("quantity-input input"),
          document.querySelector(".quantity__input"),
        ].filter(Boolean);

        quantityInputs.forEach((input) => {
          if (input && parseInt(input.value) !== 1) {
            input.value = 1;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            input.dispatchEvent(
              new CustomEvent("quantity:change", {
                detail: { quantity: 1 },
                bubbles: true,
              })
            );
          }
        });
      }

      getProductData() {
        const sid =
          document
            .querySelector(".product__info-container,[data-section]")
            ?.getAttribute("data-section") ||
          document
            .querySelector("[data-section-id]")
            ?.getAttribute("data-section-id");
        const jsonEl = document.getElementById(`ProductJson-${sid}`);
        if (!jsonEl) return null;
        return JSON.parse(jsonEl.textContent || "{}");
      }

      getCurrentVariant() {
        try {
          const sid =
            document
              .querySelector(".product__info-container,[data-section]")
              ?.getAttribute("data-section") ||
            document
              .querySelector("[data-section-id]")
              ?.getAttribute("data-section-id");
          const jsonEl = sid && document.getElementById(`ProductJson-${sid}`);
          if (!jsonEl) return null;
          const product = JSON.parse(jsonEl.textContent || "{}");
          if (!product?.variants?.length) return null;
          const selectedOptions = this.getSelectedOptions();
          if (!selectedOptions.length) {
            return null;
          }
          let variant = null;
          variant = product.variants.find((v) => {
            if (!v.options || v.options.length !== selectedOptions.length) {
              return false;
            }
            return v.options.every((option, index) => {
              const isMatch = this.matchOptionWithGrouping(
                option,
                selectedOptions[index]
              );
              if (!isMatch) {
              }
              return isMatch;
            });
          });

          if (!variant && selectedOptions.length >= 3) {
            variant = product.variants.find((v) => {
              return (
                v.option1 === selectedOptions[0] &&
                v.option2 === selectedOptions[1] &&
                v.option3 === selectedOptions[2]
              );
            });
          }
          if (!variant) {
            return null;
          }
          return variant;
        } catch (error) {
          return null;
        }
      }

      getSelectedOptions() {
        try {
          const checkedRadios = this.querySelectorAll(
            "fieldset input[type='radio']:checked"
          );
          const checkedOptions = this.querySelectorAll("select option:checked");
          const checkedInputs = [...checkedRadios, ...checkedOptions];
          const selectedOptions = Array.from(checkedInputs)
            .filter((input) => input.name !== "id")
            .map((input) => {
              if (input.tagName === "OPTION") {
                return input.value;
              }
              return input.value;
            });

          return selectedOptions;
        } catch (error) {
          return [];
        }
      }

      matchOptionWithGrouping(variantOption, selectedOption) {
        if (!variantOption || !selectedOption) {
          return false;
        }
        if (variantOption === selectedOption) {
          return true;
        }
        const extractValue = (option) => {
          if (!option || typeof option !== "string") {
            return "";
          }
          let valueByAmp = option;
          let valueByPipe = option;
          let ampContainsPipe = false;
          let pipeContainsAmp = false;

          if (option.includes("&")) {
            valueByAmp = option.split("&")[0].trim();
            if (valueByAmp.includes("|")) {
              ampContainsPipe = true;
            }
          }
          if (option.includes("|")) {
            valueByPipe = option.split("|")[0].trim();
            if (valueByPipe.includes("&")) {
              pipeContainsAmp = true;
            }
          }

          if (ampContainsPipe) {
            return valueByPipe;
          } else if (pipeContainsAmp) {
            return valueByAmp;
          } else if (option.includes("&")) {
            return valueByAmp;
          } else if (option.includes("|")) {
            return valueByPipe;
          }
          return option.trim();
        };
        const variantValue = extractValue(variantOption);
        const selectedValue = extractValue(selectedOption);
        return variantValue === selectedValue;
      }

      saveCurrentSelection() {
        try {
          const currentVariant = this.getCurrentVariant();
          if (currentVariant) {
            const selectedVariantElement = this.querySelector(
              "[data-selected-variant]"
            );
            if (selectedVariantElement) {
              selectedVariantElement.textContent =
                JSON.stringify(currentVariant);
            } else {
            }

            sessionStorage.setItem(
              "lastSelectedVariant",
              JSON.stringify({
                variantId: currentVariant.id,
                selectedOptions: this.getSelectedOptions(),
                timestamp: Date.now(),
              })
            );
          } else {
            const selectedVariantElement = this.querySelector(
              "[data-selected-variant]"
            );
            if (selectedVariantElement) {
              selectedVariantElement.textContent = "";
            }
          }
        } catch (error) {}
      }

      triggerVariantChangeEvent(target, isComboClick) {
        const currentVariant = this.getCurrentVariant();
        if (!currentVariant) {
          const partialVariant = this.findPartialMatchingVariant();
          if (partialVariant) {
            this.updateFormVariantId(partialVariant);
            this.updateURLWithVariantId(partialVariant);
            return;
          } else {
            return;
          }
        }

        this.updateFormVariantId(currentVariant);
        this.updateURLWithVariantId(currentVariant);

        const variantChangeEvent = new CustomEvent("variant:change", {
          detail: {
            variant: currentVariant,
            selectedOptionValues: this.selectedOptionValues,
          },
          bubbles: true,
        });
        document.dispatchEvent(variantChangeEvent);

        const variantChangedEvent = new CustomEvent("variant:changed", {
          detail: {
            variant: currentVariant,
            selectedOptionValues: this.selectedOptionValues,
          },
          bubbles: true,
        });
        document.dispatchEvent(variantChangedEvent);
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
          data: {
            variant: currentVariant,
            sectionId: this.dataset.section || "main",
          },
        });
      }

      updateFormVariantId(variant) {
        if (!variant) return;

        const variantInputs = document.querySelectorAll('input[name="id"]');
        variantInputs.forEach((input) => {
          input.value = variant.id;
        });
      }

      updateURLWithVariantId(variant) {
        if (!variant) return;

        try {
          const url = new URL(window.location);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url);
        } catch (error) {}
      }
      findPartialMatchingVariant() {
        try {
          const selectedOptions = this.getSelectedOptions();
          if (!selectedOptions.length) return null;

          const product = this.getProductData();
          if (!product?.variants?.length) return null;

          const matchingVariants = product.variants.filter((variant) => {
            return selectedOptions.every((selectedOption, index) => {
              return (
                !selectedOption ||
                this.matchOptionWithGrouping(
                  variant.options[index],
                  selectedOption
                )
              );
            });
          });
          return (
            matchingVariants.find((v) => v.available) ||
            matchingVariants[0] ||
            null
          );
        } catch (error) {
          return null;
        }
      }
      setVariantSelection(variant) {
        return;
      }
    }
  );
}
